import React from 'react';
import { trackEvent } from '../helpers/comman';

const features = [
  {
    title: 'Simple Integration, Instant Activation',
    description: 'Integrating Nivritti into your store is as easy as adding a single line of code. Just drop our lightweight script into your site, and you\'re live.  For example: In case of Shopify users, it\'s even easier—simply paste our snippet into your theme.liquid file, and Nivritti starts working instantly. No complex setup. No developer headaches. Just plug, play, and sell smarter.',
    link: 'Get in touch for integration'
  },
  {
    title: 'System Advantages',
    items: [
      '<b>Conversion Optimization</b> - Turn visitors into buyers with AI-powered conversational nudges and personalized recommendations',
      '<b>Friction reduction</b> - Simplify checkout and support interactions to keep customers engaged and satisfied',
      '<b>Experience enhancement</b> - Deliver a seamless, human-like shopping journey that builds trust and loyalty',
      '<b>Operational efficiency</b> - Automate support and payment processes to reduce costs and free up your team'
    ],
    link: 'Get in touch'
  }
];

const systemNodes = [
  {
    id: 'core',
    name: 'CORE',
    type: 'NIVRITTI AI',
    position: { x: '50%', y: '50%' }
  },
  {
    id: 'channel-1',
    name: 'Orchestration',
    type: 'Payments',
    position: { x: '20%', y: '30%' }
  },
  {
    id: 'channel-2',
    name: 'Upsell Engine',
    type: 'Ecom',
    position: { x: '80%', y: '30%' }
  },
  {
    id: 'channel-3',
    name: 'Multi AI Agent',
    type: 'Agent',
    position: { x: '20%', y: '70%' }

  },
  {
    id: 'channel-4',
    name : 'Quick Checkout',
    type: 'Ecom',
    position: { x: '80%', y: '70%' }
  },
];

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
const Testimonials = () => (
  <section className="py-12 md:py-20 bg-black text-white overflow-hidden">
    <div className="container mx-auto px-4 sm:px-6">
      {/* Header */}
      <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-white">
          <span className="inline-block relative">
            What Makes Nivritti Different?
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gradient-to-r from-cyan-300 to-transparent"></span>
          </span>
        </h2>
        <p className="text-lg md:text-xl text-blue-200">
          Universal compatibility through adaptive interface architecture
        </p>
      </div>

      {/* Content Columns */}
      <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-stretch">
        {/* Left Column - Cards */}
        <div className="lg:w-1/2 w-full grid gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="group relative h-full min-h-[280px] md:min-h-[300px] rounded-xl"
            >
              {/* Card Border */}
              <div className="absolute inset-0 border border-white/20 rounded-xl group-hover:border-cyan-300/50 transition-all duration-300 overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900/10 to-blue-900/30 backdrop-blur-sm"></div>
                {/* Corner brackets */}
                <div className="absolute left-3 top-3 w-2 h-2 border-t border-l border-white/30 group-hover:border-cyan-300"></div>
                <div className="absolute right-3 top-3 w-2 h-2 border-t border-r border-white/30 group-hover:border-cyan-300"></div>
                <div className="absolute left-3 bottom-3 w-2 h-2 border-b border-l border-white/30 group-hover:border-cyan-300"></div>
                <div className="absolute right-3 bottom-3 w-2 h-2 border-b border-r border-white/30 group-hover:border-cyan-300"></div>
                {/* Glow effects */}
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:via-cyan-300/50"></div>
                <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/30 to-transparent group-hover:via-cyan-300/50"></div>
              </div>

              {/* Card Content */}
              <div className="relative h-full flex flex-col p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-medium text-white mb-4 group-hover:text-cyan-300 transition-colors">
                  {feature.title}
                </h3>
                
                {feature.description ? (
                  <p className="text-blue-100 text-base md:text-lg mb-6 group-hover:text-blue-50 transition-colors">
                    {feature.description}
                  </p>
                ) : null}
                
                {feature.items && (
                  <ul className="space-y-2 text-blue-100 text-base md:text-lg group-hover:text-blue-50 transition-colors">
                    {feature.items.map((item, i) => (
                      <li key={i} className="flex items-start">
                        <span className="text-cyan-300 mr-2 mt-1">•</span>
                        <span dangerouslySetInnerHTML={{ __html: item }} ></span>
                      </li>
                    ))}
                    <br />
                  </ul>
                )}
                
                <div className="mt-auto pt-4 border-t border-white/10 group-hover:border-cyan-300/30 transition-colors">
                  <a href="#" className="text-white font-medium inline-flex items-center hover:text-cyan-300 transition-colors">
                    {feature.link}
                    <span className="ml-2 group-hover:translate-x-1 transition-transform">→</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Right Column - Visualization */}
        <div className="lg:w-1/2 w-full">
          <div className="h-full min-h-[calc(280px*2+24px)] md:min-h-[calc(300px*2+32px)] bg-blue-900/20 border border-white/10 rounded-xl overflow-hidden relative">
            {/* Connection lines */}
            <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg">
              {systemNodes.filter(n => n.id !== 'core').map((node) => (
                <line
                  key={`line-${node.id}`}
                  x1={systemNodes[0].position.x}
                  y1={systemNodes[0].position.y}
                  x2={node.position.x}
                  y2={node.position.y}
                  stroke="#06B6D4"
                  strokeWidth="1"
                  strokeDasharray="4 2"
                  strokeOpacity="0.3"
                />
              ))}
            </svg>

            {/* Nodes */}
            {systemNodes.map((node) => (
              <div
                key={node.id}
                className={`absolute transform -translate-x-1/2 -translate-y-1/2 ${
                  node.id === 'core' 
                    ? 'w-24 h-24 md:w-32 md:h-32' 
                    : 'w-16 h-16 md:w-20 md:h-20'
                }`}
                style={{ left: node.position.x, top: node.position.y }}
              >
                <div className={`absolute inset-0 rounded-full border ${
                  node.id === 'core' 
                    ? 'border-cyan-400 bg-gradient-to-br from-cyan-400/10 to-transparent' 
                    : 'border-white/20'
                }`}></div>
                <div className="absolute inset-0 flex flex-col items-center justify-center p-2 text-center">
                  <div className={`font-mono ${
                    node.id === 'core' 
                      ? 'text-cyan-300 text-sm md:text-base' 
                      : 'text-blue-100 text-xs md:text-sm'
                  }`}>
                    {node.name}
                  </div>
                  <div className={`font-mono mt-1 ${
                    node.id === 'core' 
                      ? 'text-cyan-400/60 text-xs' 
                      : 'text-cyan-400/40 text-[10px]'
                  }`}>
                    {node.type}
                  </div>
                </div>
              </div>
            ))}

            {/* Grid pattern */}
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:24px_24px]"></div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-12 md:mt-16 text-center">
        <button onClick={() =>{ handleScrollToTop(); trackEvent("btn_request_integration_demo_clicked")}} className="px-8 py-3.5 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-white font-medium hover:from-cyan-300 hover:to-blue-400 transition-all text-lg relative overflow-hidden group">
          <span className="relative z-10">Request Integration Demo</span>
          <span className="absolute inset-0 bg-gradient-to-r from-cyan-300 to-blue-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
        </button>
      </div>
    </div>
  </section>
);

export default Testimonials;
